export default __webpack_public_path__ + "static/media/srinivas.bf538804.png";